/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, OnDestroy, Output, TemplateRef, ChangeDetectorRef, SimpleChanges } from '@angular/core';

/**
 * Constant imports.
 */
import {STORY_TYPES, STORY_DEFAULT_DURATION } from '../../../../app/constants/app.constants';
/**
 * service imports
 */
import { UserStoryService } from 'src/app/dataservices/userStory/user-story.service';
import { OnChange } from 'src/app/custom-decorators/ngOnchanges.Decorator';
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';

/**
 * Collection of all types of stories.
 */
@Component({
  selector: 'app-story-main',
  templateUrl: './story-main.component.html',
  styleUrls: ['./story-main.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoryMainComponent implements OnDestroy {


  // TODO: Rahul: to do datatyping
  /**
   * To add the Custom component.
   * To add the header in the story.
   * Story detail.
   */
  @Input() customComponent: TemplateRef<HTMLElement>;
  @Input() profileImage: any;
  @Input() isMe: boolean;
  @Input() type: any;
  @Input() fullName: string;
  @Input() channelId: number;
  @Input() activeIndex: number;
  @Input() readonly story: any;
  @Input() readonly headerDropdownList: { id: number, text: string };
  @Input() stories;
  @Input() duration: number;
  @Input() isMuted: boolean;


  @Input() userType: string;

  @Input() reactionCount;

  @Input() viewCount;

  @Input() longPressedEvent;

  @Input() storyViewList = [];

  @Input() showVolume: boolean;

  @Input() createdOn: number;

  @Input() speciality: string;

  @Input() currentPlaying;

  @Input() fileType;

  @Input() viewListByDefault = false;

  @Input() storyProgressPercentage: string;
  @Input() autoStart;
  @OnChange<boolean>('onStoriesChange')
  @Input() storiesChange;



  /**
   * Emit the generated meta.
   * Emit the Request for the API
   * Emit the Actions for the header dropdown.
   * Emit flag to start/pause the progress.
   * Emit the cta target.
   * Emit action on generated Meta.
   */
  @Output() emitRequest: EventEmitter<boolean> = new EventEmitter();
  @Output() emitAction: EventEmitter<number> = new EventEmitter();
  @Output() emitToggleProgressCounter: EventEmitter<boolean> = new EventEmitter();
  @Output() emitCtaTarget: EventEmitter<any> = new EventEmitter();
  @Output() emitOnMeta: EventEmitter<string> = new EventEmitter();

  @Output() emitDuration: EventEmitter<number> = new EventEmitter();

  @Output() emitReaction: EventEmitter<{value: string, storyCode: string}> = new EventEmitter();

  @Output() emitViewListScrolled: EventEmitter<void> = new EventEmitter();

  @Output() emitViewListClicked: EventEmitter<void> = new EventEmitter();

  @Output() emitClose: EventEmitter<void> = new EventEmitter();
  @Output() emitToggleMuteStatus: EventEmitter<boolean> = new EventEmitter();

  @Output() profileRedirectEmit: EventEmitter<string> = new EventEmitter();

  @Output() deepLinkRedirectEmit: EventEmitter<string> = new EventEmitter();

  @Output() lockScreen: EventEmitter<boolean> = new EventEmitter();

  @Output() headerRedirect: EventEmitter<any> = new EventEmitter();
  
 /**
  * reset animation flag
  */
  public resetAnimation = 0;

  defaultDuration = STORY_DEFAULT_DURATION;


  public isTagMetaGenerated: boolean;

  /**
   * show view list flag
   */
  public showViewList = false;

  /**
   *  audioStatus
   */
  public audioStatus;

  /**
   * tag meta content
   */
  public tagMetaContent;

  public isMetaViewActive = false;

  public isHeaderMenuActive = false;

  public isImageLoadingOrMetaGenerated = false;

  public isViewListActive = false;
  /**
   * Which story type from the constant.
   */
  readonly STORY_TYPES = STORY_TYPES;

  constructor(
    public storyserv: UserStoryService,
    public mls: NewLanguageService,
    public cd:ChangeDetectorRef
  ) {
    
  }
  ngOnDestroy(): void {
    // no code
  }
  /**
   * onStoriesChange
   */
  onStoriesChange(): void {
    this.resetAnimation = this.resetAnimation + 1;
    this.showViewList = false;
    this.viewListByDefault = false;
  }

  headerMenuToggle(status): void {
    this.isHeaderMenuActive = status;
    this.toggleProgressCounter(status);
  }
  closeStory(): void {
    this.emitClose.emit();
  }
  /**
   * disabling left and right gestures
   */
  lockScreenEvent(event): void {
    this.isImageLoadingOrMetaGenerated = event;
    this.toggleProgressCounter(event);
    this.lockScreen.emit(event);
  }
  /**
   * toggle audio status
   */
  changeAudioStatus(event): void {
    this.audioStatus = event;
    this.emitToggleMuteStatus.emit(event);
  }

  setTagContent(event): void {
    this.tagMetaContent = event;
    this.isTagMetaGenerated = true;
  }

  /**
   * for profile navigation
   */
  navigateToProfile(): void {
    this.headerRedirect.emit();
  }
  /**
   * profile redirection
   * @param event
   */
  deepLinkRedirect(event): void {
    this.deepLinkRedirectEmit.emit(event);
  }
  profileRedirection(event): void {
    this.profileRedirectEmit.emit(event);
  }
  /**
   * 
   * @param event profile redirection
   */
  profileRedirect(event): void {
    this.profileRedirectEmit.emit(event);
  }
  /**
   * Emit the Request for the API
   */
  sendRequest(): void {
    this.emitRequest.emit();
  }

  /**
   * Emit the Actions for the header dropdown.
   */
  doAction(action: number): void {
    this.toggleProgressCounter(true);
    this.emitAction.emit(action);
  }

  /**
   * Emit flag to start/pause the progress.
   */
  toggleProgressCounter(status: boolean): void {
    if (this.viewListByDefault === true || this.isHeaderMenuActive === true || this.isImageLoadingOrMetaGenerated === true || this.showViewList === true) {
      this.emitToggleProgressCounter.emit(true);
    }
    else {
      this.emitToggleProgressCounter.emit(status);
    }
  }

  /**
   * Emit the cta target.
   */
  onEmitCtaTarget(target: any): void {
    this.toggleProgressCounter(true);
    this.emitCtaTarget.emit(target);
  }
  /**
   * sort cta on basis of primary and secondart
   */
  getCta(ctaArray): any[] {
    let secondaryPosition = -1;
    for (let i = 0; i < ctaArray.length; i++) {
      if (ctaArray[i].ctaType.toLowerCase() === 'secondary') {
        secondaryPosition = i;
      }
    }
    if (secondaryPosition === -1) {
      return ctaArray;
    }
    else {
      const secondaryData = ctaArray[secondaryPosition];
      ctaArray.splice(secondaryPosition, 1);
      ctaArray.unshift(secondaryData);
    }
    return ctaArray;
  }
  /**
   * decode video
   */
  getVideoUrl(videoId): any {
    let videoUrl;
    if (videoId.indexOf('http') !== -1 ) {
      videoUrl =  videoId;
    }
    else {
      videoUrl = this.storyserv.fileCodeUrlMap.get(videoId);
    }
    return videoUrl;
  }
  /**
   * 
   * @param event emit video duration
   */
  emitVideoDuration(event): void {
    this.emitDuration.emit(event);
  }
  /**
   * 
   * @param event 
   */
  viewListScroll(): void  {
    this.emitViewListScrolled.emit();
  }
  /**
   * 
   * @param event 
   */
  viewListClicked(event): void {
    this.showViewList = event;
    this.toggleProgressCounter(event);
    this.emitViewListClicked.emit(event);
  }

  /**
   * 
   * @param event logging reactions
   */
  reactionLog(event): void {
    const data = {value: event, storyCode: this.story.storyCode};
    this.emitReaction.emit(data);
  } 
  /**
   * function to check whether to show reactions or not
   */
  showReactions(): boolean {
    if (this.userType === STORY_TYPES.PHARMA) {
      for (let i = 0; i < this.story.cta.length; i++) {
        if (this.story.cta[i].type === STORY_TYPES.TEMPLATE) {
          return false;
        }
      }
      return true;
    }
    else {
      return true;
    }
  }
  getFlickerValue(): number {
    return Math.min(4, this.viewCount);
  }

  /**
   * reset animation
   */
}
